import { WbacService } from '@cinch/oxd-utils/requests/src'
import * as Storage from '@cinch/oxd-utils/storage/src'
import { useEffect, useState } from 'react'

import Statuses, { RequestStatus } from '@cinch/oxd-utils/request-status/src'

import { BookResponse, Site } from '../../types'

const fetchSite = async (siteId: number) => {
  const { token: storageToken } = Storage.get(Storage.StorageKeys.wbac)
  const result = await WbacService.get(`/sites/${siteId}`, {
    headers: { Authorization: `JWT ${storageToken}` },
  })

  return result.data
}

const useAppointment = (appointment: BookResponse) => {
  const [siteStatus, setSiteStatus] = useState<RequestStatus>(Statuses.INITIAL)
  const [site, setSite] = useState<Site | undefined>(undefined)

  useEffect(() => {
    fetchSite(appointment.siteId)
      .then((res) => {
        setSite(res)
        setSiteStatus(Statuses.SUCCESS)
      })
      .catch(() => {
        setSiteStatus(Statuses.ERROR)
      })
  }, [appointment])

  return {
    site,
    siteStatus,
  }
}

export default useAppointment
